import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const createAuthBaseQuery = () =>
  fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
